module.exports = __webpack_public_path__ + "static/media/2.pic.f7ad4987.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/2.pic.jpg
// module id = 286
// module chunks = 0